import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import ModalLiga from "@/components/Liga/ModalLiga.vue";
import { LigaDTO } from "@/interfaces/Liga";
import { getLigas } from "@/services/LigasService";
import { ref, onMounted } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'LigasView',
  setup(__props) {

const showModalLiga = ref<boolean>(false);
const selectedLiga = ref<LigaDTO | null>(null);

// Referencia para almacenar las ligas
const ligas = ref<LigaDTO[]>([]);
const loading = ref<boolean>(false);

// Función para cargar las ligas
const loadLigas = async () => {
  loading.value = true;
  try {
    const response = await getLigas();
    ligas.value = response.data;
  } catch (error) {
    console.error("Error al cargar ligas:", error);
  } finally {
    loading.value = false;
  }
};

// Función para abrir el modal con los detalles de la liga seleccionada
const openDialog = (liga: LigaDTO) => {
  selectedLiga.value = liga;
  showModalLiga.value = true;
};

const closeModal = () => {
  showModalLiga.value = false;
};

// Cargar ligas cuando el componente esté montado
onMounted(() => {
  loadLigas();
});

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ligas.value, (liga) => {
            return (_openBlock(), _createBlock(_component_v_col, {
              key: liga.idLiga,
              cols: "12",
              sm: "6",
              md: "4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, {
                  onClick: ($event: any) => (openDialog(liga))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_title, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(liga.nombreLiga), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }),
      (showModalLiga.value)
        ? (_openBlock(), _createBlock(ModalLiga, {
            key: 0,
            liga: selectedLiga.value,
            onClose: closeModal
          }, null, 8, ["liga"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})